import React from 'react';
import { ChangePasswordCard, ProfileDetailsCard } from 'components/profileDetails';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import styled, { useTheme } from 'styled-components';
import { STYLES } from 'utils/constants/styles';
import { Title } from 'components/common/text';
import { PortalTabs } from 'components/portalScreening';
import { useStateContext } from 'store/state';

const StyledContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 1250px) {
        width: 1000px;
    }
`;

const StyledFirstRow = styled(Row)`
    border-radius: ${STYLES.BORDER_RADIUS};
    background-color: ${props => props.theme.background.table};
    padding: 12px 0;
    margin-bottom: 32px;
`;

const ProfileDetailsView: React.FC = () => {
    const { t } = useTranslation('profileDetails');

    const {
        state: {
            user: { requirePasswordChange },
        },
    } = useStateContext();

    const theme: any = useTheme();

    return (
        <StyledContainer>
            <Title style={{ textAlign: 'center' }} level={0}>
                {t('examinationDetails:patient_portal')}
            </Title>
            {requirePasswordChange && (
                <Title style={{ textAlign: 'center', color: theme?.text?.red }} level={0}>
                    {t('pwd_change_required')}
                </Title>
            )}
            <PortalTabs />
            <Title style={{ margin: '0 auto', marginBottom: '16px' }}>{t('my_data_title')}</Title>
            <StyledFirstRow>
                <Col span={24} lg={12}>
                    <Title style={{ paddingLeft: '15%', margin: 0 }} level={3}>
                        {t('my_data_title')}
                    </Title>
                </Col>
                <Col span={24} lg={12}>
                    <Title style={{ paddingLeft: '15%', margin: 0 }} level={3}>
                        {t('change_password')}
                    </Title>
                </Col>
            </StyledFirstRow>
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Col span={24} lg={12}>
                    <ProfileDetailsCard />
                </Col>
                <Col span={24} lg={12}>
                    <ChangePasswordCard />
                </Col>
            </Row>
        </StyledContainer>
    );
};

export default ProfileDetailsView;
